/**
 * Какое нажатие на ссылку материала считается открытием
 * (`docs/material-receipt-design.md`, разделы 6 и 9.3: отметка ставится по
 * жесту перехода, а не по чему угодно рядом со ссылкой).
 *
 * `click` приходит только от основной кнопки, и там вопроса нет. Вопрос в
 * `auxclick`: браузеры шлют его и на СРЕДНЮЮ кнопку (открыть во вкладке, это
 * переход), и на ПРАВУЮ (контекстное меню, где «копировать адрес» переходом не
 * является). Отметка по правой кнопке ставила бы ученику «Открыт» за то, что он
 * скопировал адрес, то есть ровно ту ложную квитанцию, против которой написан
 * раздел 6.
 *
 * Номер кнопки по `MouseEvent.button`: 0 основная, 1 средняя, 2 правая.
 *
 * Читателей два: квитанция материалов (`MyMaterialsPage.tsx`) и отметка нажатия
 * на ссылку текста задания (`LinkifiedText.tsx`, Р9
 * `docs/homework-media-plan.md`), поэтому модуль живёт в `lib/`.
 */
export function auxClickOpens(button: number): boolean {
  return button === 1;
}
